<template>
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="21" height="21" rx="10.5" fill="#736151"/>
        <path d="M8.6835 7.03265C8.35278 7.03271 8.08468 7.30092 8.08462 7.63153C8.08462 7.96242 8.35272 8.23052 8.68367 8.23047L11.9383 8.23041L7.22628 12.9434C6.99246 13.1773 6.99246 13.5564 7.22645 13.7904C7.46039 14.0242 7.83945 14.0242 8.07333 13.7903L12.7855 9.07718L12.7854 12.3326C12.7854 12.6633 13.0536 12.9316 13.3844 12.9315C13.5497 12.9314 13.6995 12.8645 13.8079 12.7561C13.9163 12.6477 13.9832 12.4979 13.9834 12.3326L13.9834 7.63142C13.9835 7.47258 13.9204 7.32029 13.808 7.20792C13.6956 7.09561 13.5434 7.0326 13.3844 7.03248L8.6835 7.03265Z" fill="white"/>
    </svg>
</template>
  
<script>
    export default {
        name: "LinkIcon",
    };
</script>
  